import React, { useState } from "react";
import "./Maintenance.css";

export default function SlidingText() {
  const [showNoticeAll, setShowNoticeAll] = useState(true);
  const [showNotice, setShowNotice] = useState(false);

  const systemSchedular = localStorage.getItem("system-schedular");

  const message = systemSchedular ? systemSchedular.replaceAll(/["]/g, "").replaceAll("\\n", "\n") : "";
  

//   const message = `Dear Customer,

// We would like to inform you that Dhobicart services will be temporarily unavailable due to a scheduled system upgrade and maintenance.

// Date: 28-July-2026

// Downtime: 9:00 PM to 6:00 AM

// Expected Duration: Maximum 9 hours

// During this maintenance window, you may be unable to access the platform or use certain services.

// We request you to plan your activities accordingly and complete any important tasks before the scheduled downtime.

// We sincerely apologize for any inconvenience and appreciate your patience and support while we work to improve our services.

// Thank you,

// Team Dhobicart`

  return (
    <>
      {/* Announcement Banner */}
     {showNoticeAll && <div className="maintenance-banner">
        <div className="maintenance-icon">⚠</div>

        <div className="maintenance-info">
          <div className="maintenance-title">Alert</div>

          {/* <div className="maintenance-summary">
            Dhobicart services will be temporarily unavailable due to scheduled
            system upgrade and maintenance.
          </div> */}

          {/* <div className="maintenance-details">
            <span>
              📅 <strong>28-July-2026</strong>
            </span>

            <span>
              🕘 <strong>9:00 PM – 6:00 AM</strong>
            </span>

            <span>
              ⏱ <strong>Maximum 9 hours</strong>
            </span>
          </div> */}
        </div>

        <button className="notice-button" onClick={() => setShowNotice(true)}>
          Read
        </button>

        <div className="close-message">
          <button
                className="close-button-message"
                onClick={() => setShowNoticeAll(false)}
              >
                ×
              </button>
        </div>
      </div>}

      {/* Full Notice Modal */}
      {showNotice && (
        <div className="notice-overlay" onClick={() => setShowNotice(false)}>
          <div className="notice-modal" onClick={(e) => e.stopPropagation()}>
            <div className="notice-header">
              <div>
                <div className="notice-header-title">
                  ⚠ Scheduled Maintenance
                </div>

                <div className="notice-header-subtitle">
                  Important service notification
                </div>
              </div>

              <button
                className="close-button"
                onClick={() => {
                    setShowNotice(false);
                    setShowNoticeAll(false)
                    }}
              >
                ×
              </button>
            </div>

            {/* Dynamic Message */} <div className="notice-body"> <div className="dynamic-message"> {message} </div> </div>

            {/* <div className="notice-body">
         
              <p>Dear Customer,</p>

              <p>
                We would like to inform you that Dhobicart services will be
                temporarily unavailable due to a scheduled system upgrade and
                maintenance.
              </p>

              <div className="notice-highlight">
                <div>
                  <span>Date</span>
                  <strong>28-July-2026</strong>
                </div>

                <div>
                  <span>Downtime</span>
                  <strong>9:00 PM to 6:00 AM</strong>
                </div>

                <div>
                  <span>Expected Duration</span>
                  <strong>Maximum 9 hours</strong>
                </div>
              </div>

              <p>
                During this maintenance window, you may be unable to access the
                platform or use certain services.
              </p>

              <p>
                We request you to plan your activities accordingly and complete
                any important tasks before the scheduled downtime.
              </p>

              <p>
                We sincerely apologize for any inconvenience and appreciate your
                patience and support while we work to improve our services.
              </p>

              <p className="thank-you">
                Thank you,
                <br />
                <strong>Team Dhobicart</strong>
              </p>
            </div> */}

            <div className="notice-footer">
              <button
                className="got-it-button"
                onClick={() => {
                    setShowNotice(false);
                    setShowNoticeAll(false)
                    }}
              >
                Got it
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
